export const technicianProfileKeys = {
  all: ['technician-profile'] as const,

  list: () => [...technicianProfileKeys.all, 'list'] as const,
}
